
/* injects from baggage-loader */

'use strict';

import _ from 'lodash';

export default class PageFiveController {
	constructor($log, $state, $timeout, $interval, Session, Dialog) {
		'ngInject';
		this.$log = $log;  
		this.$state = $state;
		this.$timeout = $timeout;
		this.$interval = $interval;
		this.Session = Session;
		this.Dialog = Dialog;
		this.mouseIsDown = false;
		this.lastIndex = -1;
		this.words = [
		[13,14,15,16,17,18,19,20,21,22],
		[10,22,34,46,58,70,82,94,106],
		[97,98,99,100,101,102,103,104,105,106],
		[121,122,123,124,125,126,127,128,129]
		];
		this.findedWords = [];
		this.hunt = [false, false, false, false];
	}

	$onInit(){
		this.wordHunt = ['B', 'R', 'N', 'M', 'L', 'K', 'J', 'A', 'Z', 'X', 'C', 'V',
		'S', 'A', 'M', 'A', 'R', 'E', 'L', 'I', 'N', 'H', 'A', 'U',
		'H', 'C', 'A', 'D', 'I', 'G', 'B', 'H', 'I', 'J', 'B', 'T',
		'R', 'A', 'D', 'P', 'O', 'C', 'N', 'M', 'L', 'I', 'R', 'A', 
		'S', 'T', 'S', 'E', 'D', 'R', 'Q', 'N', 'P', 'R', 'A', 'R', 
		'E', 'O', 'V', 'G', 'F', 'O', 'P', 'A', 'Q', 'E', 'C', 'Q', 
		'D', 'V', 'A', 'D', 'A', 'G', 'D', 'F', 'G', 'H', 'E', 'U', 
		'E', 'I', 'T', 'Z', 'B', 'E', 'H', 'I', 'L', 'J', 'G', 'I', 
		'J', 'F', 'A', 'Z', 'D', 'E', 'C', 'O', 'N', 'T', 'A', 'K', 
		'F', 'L', 'A', 'M', 'E', 'N', 'I', 'R', 'I', 'V', 'U', 'E', 
		'G', 'V', 'I', 'D', 'E', 'O', 'G', 'A', 'M', 'E', 'I', 'M', 
		'F', 'O', 'R', 'E', 'M', 'A', 'D', 'E', 'C', 'J', 'S', 'L'];
		this.wordFind = [];
		this.feedback = require('_images/page-five/feedback.png');
	}

	check(){
		for(let i = 0; i<this.words.length; i++){
			let check = _.sortBy(this.wordFind)
			if(_.isEqual(this.words[i],check)){
				this.findedWords.push(this.wordFind);
				this.hunt[i] = true;
			}
		}

		this.boxClass = "box"+_.sum(this.hunt);
		this.wordFind = [];
		this.findedWords = _.flatten(this.findedWords);
		if(_.isEqual(this.findedWords, _.flatten(this.words))){
			this.$timeout(() => this.Dialog.showEmbedded(this.feedback, 0, this.redirectToStages.bind(this)),100);
		}
	}

	clicked(index){
		if(_.includes(this.findedWords,index))
			return 'checked'
		else if(_.includes(this.wordFind,index))
			return 'clicked';
		else
			return false
	}

	clickLetter(index){
		if(this.lastIndex!==index){
			if (this.mouseIsDown){
				if(_.includes(this.wordFind,index)){
					if(_.includes(this.findedWords,index))
						this.wordFind.push(index);
					else
						_.pull(this.wordFind,index);
				}
				else
					this.wordFind.push(index);
				this.lastIndex = index;
			}
		}
	}

	$onDestroy(){
		this.resetStage();
	}

	setFlag(index){
		this.mouseIsDown = true;
		this.clickLetter(index);
	}

	removeFlag(){
		this.mouseIsDown = false;
		this.$log.log(_.now());
		this.check();
	}

	resetStage() {        
		return false;
	}

	redirectToStages(){
		if(_.isEqual(this.findedWords, _.flatten(this.words)))
			this.$state.go("page-six");
		else
			this.$state.go("page-six");
			//alert("Você ainda não completou a fase!");
	}
}


// WEBPACK FOOTER //
// ./src/app/pages/page-five/page-five.controller.js